module.exports = __webpack_public_path__ + "img/6.79af4d04.png";